var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo",domProps:{"innerHTML":_vm._s(_vm.logo)}})
}
var staticRenderFns = []

export { render, staticRenderFns }